import { render, staticRenderFns } from "./StudentMenuSection.vue?vue&type=template&id=544d495e&scoped=true&"
import script from "./StudentMenuSection.vue?vue&type=script&lang=js&"
export * from "./StudentMenuSection.vue?vue&type=script&lang=js&"
import style0 from "./StudentMenuSection.vue?vue&type=style&index=0&id=544d495e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544d495e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
